module.exports = __webpack_public_path__ + "img/night_star.c814c113.png";